<template>
  <div class="settlement-detail">
    <!-- <div class="title-wrap">

      <span
        class="prev-page"
        @click="$router.push({ name: 'StudioIncomeSettlement' })"
        >结算中心</span
      >
      <img
        class="icon-arrows"
        src="../../assets/images/icon_page_connector.png"
      />
      <span class="current-page">提现记录</span>
    </div> -->
    <div class="query-form">
      <el-form
        ref="recordForm"
        :inline="true"
        :rules="rules"
        :model="formInline"
        class="form-inline"
      >
        <el-form-item label="选择日期" prop="date" style="margin-right: 0">
          <el-date-picker
            v-model="formInline.date"
            type="daterange"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            @change="changeDate"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <div class="btn-query" @click="queryTableFn">查找</div>
        </el-form-item>
        <el-form-item label="货币类型">
          <el-select
            style="width: 90px; margin-right: 70px"
            class="select-input"
            v-model="formInline.moneyType"
            placeholder="货币类型"
          >
            <el-option
              size="medium"
              :label="type.name"
              :value="type.id"
              v-for="type in moneyTypeArr"
              :key="type.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <Table
      v-loading="loading"
      :tableData="tableData"
      :tableField="tableField"
      key="workDetail"
      :tableInfo="tableInfo"
      @changePage="changePageFn"
    ></Table>
  </div>
</template>

<script>
import { errorTip } from '@/utils/index';
import Table from './components/table';
import { getRecordList } from '@/api/income';
export default {
  name: 'settlementDetail',
  components: {
    Table,
  },
  data() {
    return {
      loading: false,
      formInline: {
        moneyType: 999,
        date: [new Date() - 3600 * 1000 * 24 * 30, new Date()],
      },
      rules: {
        date: [{ required: true, message: '请选择日期', trigger: 'blur' }],
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() + 0 * 24 * 3600 * 1000 > Date.now();
        },
      },
      tableInfo: {
        page: 1,
        pageSize: 20,
        total: 0,
      },
      tableData: [],
      tableField: [
        { label: '日期', prop: 'create_time' },
        {
          label: '订单号',
          prop: 'id',
        },
        {
          label: '类型',
          prop: 'money_type',
        },
        {
          label: '提现数额',
          prop: 'money',
        },
        {
          label: '税费',
          prop: 'taxe',
        },
        {
          label: '手续费',
          prop: 'service_charge',
        },
        {
          label: '到账金额',
          prop: 'real_money',
        },
        {
          label: '状态',
          prop: 'state',
        },
        {
          label: '操作',
          prop: 'operation',
        },
      ],
      moneyTypeArr: [
        { id: 999, name: '全部' },
        { id: 1, name: '现金' },
        { id: 2, name: '迷你豆' },
      ],
    };
  },
  computed: {
    getDate() {
      let timeArr = [];
      if (typeof this.formInline.date[0] == 'number') {
        // 默认筛选
        timeArr = [
          new Date(
            new Date(new Date() - 3600 * 1000 * 24 * 30).toString(),
          ).getTime() / 1000, // 0点时间戳

          new Date(new Date(new Date()).toString()).getTime() / 1000 +
            (24 * 60 * 60 - 1), // 当天23:59:59点时间戳
        ]; //23:59:59点时间戳;
      } else {
        // 修改日期筛选
        timeArr = [
          new Date(new Date(this.formInline.date[0]).toString()).getTime() /
            1000,
          new Date(new Date(this.formInline.date[1]).toString()).getTime() /
            1000 +
            24 * 60 * 60 -
            1,
        ];
      }
      return timeArr;
    },
  },
  watch: {
    formInline: {
      handler() {
        this.tableInfo.page = 1;
        this.fetchRecordList();
      },
      deep: true,
    },
  },
  mounted() {
    this.fetchRecordList();
    this.withdrawShow();
  },
  methods: {
    //提现记录页曝光埋点
    withdrawShow() {
      this.$log('withdrawa_record_show', 85435, { v7: 1 });
      // console.log('+++' + '35');
    },
    async fetchRecordList() {
      try {
        this.loading = true;
        let data = {
          // 默认请求最近一周
          money_type: this.formInline.moneyType,
          start_time: this.getDate[0],
          end_time: this.getDate[1],
          page: this.tableInfo.page,
          page_size: this.tableInfo.pageSize,
          dtype: 1,
        };
        const res = await getRecordList(data);

        this.tableData = res.data.list;
        this.tableInfo.total = res.data.total_count;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    changeDate(val) {
      if (val != null) {
        if ((val[1] - val[0] + 1) / 1000 / 60 / 60 / 24 > 365) {
          errorTip('最多选择一年，请重新选择查询时间');
        }
      }
    },
    queryTableFn() {
      this.$refs.recordForm.validateField('date', errMsg => {
        if (!errMsg) {
          let days = Math.round(
            (this.getDate[1] - this.getDate[0]) / 60 / 60 / 24,
          );
          days > 365
            ? errorTip('最多选择一年，请重新选择查询时间')
            : this.fetchRecordList();
        }
      });
    },
    changePageFn(val) {
      this.tableInfo.page = val;
      this.fetchRecordList();
    },
  },
};
</script>

<style lang="scss" scoped>
$--color-primary: #fd9b21;

.settlement-detail {
  font-size: 14px;
  .title-wrap {
    font-size: 24px;
    color: #595959;
    padding-bottom: 24px;
    border-bottom: 1px solid rgba(217, 217, 217, 1);
    margin-bottom: 24px;
    .icon-arrows {
      margin: 0 24px;
      color: #8c8c8c;
    }
    .prev-page {
      cursor: pointer;
    }
    .current-page {
      color: #8c8c8c;
    }
  }

  .query-form {
    width: 100%;
    .el-form-item {
      margin-right: 95px;
    }

    .btn-query {
      width: 64px;
      height: 40px;
      background: #f5f5f5;
      border: 1px solid #d9d9d9;
      border-radius: 0px 4px 4px 0px;
      text-align: center;
      line-height: 40px;
      margin-left: -2px;
      cursor: pointer;
      &:hover {
        color: $--color-primary;
        background-color: #fffaed;
        border: 1px solid #ffc973;
      }
    }
  }
}
::v-deep {
  .el-range-separator {
    padding: 0;
  }
  .el-form-item__label {
    color: #262626;
  }
}
::v-deep
  .el-form-item.is-required:not(.is-no-asterisk)
  .el-form-item__label-wrap
  > .el-form-item__label:before,
::v-deep
  .el-form-item.is-required:not(.is-no-asterisk)
  > .el-form-item__label:before {
  content: '';
}
</style>
